var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28698 9.54166C7.21039 9.54202 7.13449 9.52708 7.06375 9.49772C6.99301 9.46835 6.92884 9.42515 6.87502 9.37065L4.1778 6.65012C4.10676 6.54056 4.07457 6.41031 4.08637 6.28027C4.09818 6.15022 4.1533 6.02791 4.24291 5.93293C4.33251 5.83794 4.45141 5.77579 4.58055 5.75644C4.70969 5.73709 4.84158 5.76165 4.9551 5.82619L7.28698 8.15807L9.61887 5.82619C9.73239 5.76165 9.86428 5.73709 9.99342 5.75644C10.1226 5.77579 10.2415 5.83794 10.3311 5.93293C10.4207 6.02791 10.4758 6.15022 10.4876 6.28027C10.4994 6.41031 10.4672 6.54056 10.3962 6.65012L7.67563 9.37065C7.57263 9.47514 7.4336 9.53631 7.28698 9.54166Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlack);
export default __webpack_public_path__ + "static/media/chevron-down-black.9209ec548895c83b1b8404845454b388.svg";
export { ForwardRef as ReactComponent };